import { usePostRoadmapNode } from '@/api/rest/resources/organization';
import { PostOrganizationRoadmapNodesRequestBodyData } from '@/api/rest/resources/types/organization';

export const useEditRoadmapNode = () => {
  const mutation = usePostRoadmapNode();

  const submit = async ({
    organizationId,
    onSuccess,
    inputs,
  }: {
    organizationId: string;
    inputs: PostOrganizationRoadmapNodesRequestBodyData;
    onSuccess?: () => void;
  }) => {
    const response = await mutation.mutateAsync({
      pathVariables: { organization_id: organizationId },
      bodyData: inputs,
    });

    onSuccess?.();

    return response;
  };

  const isSubmitting = mutation.isPending;

  return { submit, isSubmitting };
};
